import { gql, useMutation } from '@apollo/client'

const FORM_UPDATE_MUTATION = gql`
  mutation FormUpdate($formId: Long!, $form: FormUpdate!) {
    formUpdate(id: $formId, form: $form) {
      id
      name
      beginDate
      endDate
      sector {
        id
        name
      }
      questions {
        id
        text
        dimension {
          id
          name
        }
      }
      errors {
        message
      }
    }
  }
`

export function useFormUpdateMutation(...args) {
  const [mutation, { data, ...rest }] = useMutation(FORM_UPDATE_MUTATION, ...args)

  return [
    (...args) =>
      mutation(...args).then(({ data: { formUpdate }, ...rest }) => ({
        data: formUpdate,
        ...rest
      })),
    {
      data: data?.formUpdate,
      ...rest
    }
  ]
}
